import { Text, type UiTextProps } from "../text";

export type ListItemButtonTextProps = Omit<UiTextProps, "size"> & {
  size?: UiTextProps["size"];
};

export function ListItemButtonText(props: ListItemButtonTextProps) {
  return <Text.Ui size="md" {...props} />;
}
